import { render, staticRenderFns } from "./IQThinkingBanner.vue?vue&type=template&id=1c696f02&scoped=true"
import script from "./IQThinkingBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./IQThinkingBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQThinkingBanner.vue?vue&type=style&index=0&id=1c696f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c696f02",
  null
  
)

export default component.exports